import React, { useEffect, useMemo, useRef, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import arrowDown from "../../../assets/images/icons/arrow-down.svg"
import eye from "../../../assets/images/icons/eye.svg"
import { Link } from "react-router-dom"
import moment from "moment"
import {
  formatAmount,
  formatTenure,
  getIcdRequestStatus,
  getIcdsStatus,
} from "helpers/common"
import { useLazyMyInterestsQuery } from "store/api/investorapi/icds.api"
import LoaderComponent from "components/loader"
const defaultFilters = {
  search: "",
  page: 1,
  created_by: "ADMIN",
  pageSize: 20,
  timestamp: "",
}

const MyICDInterests = () => {
  const [getResults, { isFetching }] = useLazyMyInterestsQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)

  //meta title
  document.title = "My ICD interests - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(() => [
    {
      header: () => (
        <div className="flex items-center gap-2">
          Request ID <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "unique_code",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-number">{row?.original.unique_code}</div>
      ),
    },

    {
      header: () => (
        <div className="flex items-center gap-2">
          Amount (₹) <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "amount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => <div>₹ {formatAmount(row?.original.amount)}</div>,
    },
    {
      header: () => (
        <div className="flex items-center gap-2">
          Interest <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{row?.original.interest_rate} %</div>
      ),
    },
    {
      header: () => (
        <div className="flex items-center gap-2">
          Tenure <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "tenure",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{formatTenure(row?.original.tenure)}</div>
      ),
    },
    {
      header: () => (
        <div className="flex items-center gap-2">
          Fund Availability Date <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "fund_requirement_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>{moment(row?.original.fund_requirement_date).format("D MMM YYYY")}</>
      ),
    },
    {
      header: () => (
        <div className="flex items-center gap-2">
          Status <img src={arrowDown} height={"15px"} alt="" />
        </div>
      ),
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-status">
          {["OPEN", "CLOSED", "CANCELLED", "REJECTED"].includes(
            row?.original?.icds?.status
          ) || !row?.original?.approved_at
            ? getIcdRequestStatus(row?.original.status)
            : getIcdsStatus(row?.original?.icds?.status)}
        </div>
      ),
    },
    {
      id: "action",
      header: "",
      cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <div className="action-view">
            <Link
              to={`/icd-investments/my-icd/interest/view/${row?.original.id}`}
            >
              <img src={eye} alt="" />
            </Link>
          </div>
        </div>
      ),
    },
  ])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="p-0">
          <Breadcrumbs title={"My ICD interests"} breadcrumbItem={"ICDs"} />
          {isFetching ? (
            <LoaderComponent />
          ) : (
            <TableContainer
              isLoading={isFetching}
              count={count}
              filters={filters}
              setFilters={setFilters}
              columns={columns}
              data={data}
              isGlobalFilter={true}
              isCustomPageSize={false}
              // isGlobalFilter={true}
              isPagination={false}
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MyICDInterests
